import type { MapHitEvent, MapSurface } from '@gpx-spa/geo-domain';
import { htmlSurface, isMarkerHit, textSurface } from '@gpx-spa/geo-domain';

const EXCEPTION_MARKER_ID_PREFIX = 'exception-';

/** Popup/tooltip for exception map markers (card title already set on `marker.popup`). */
export function exceptionMarkerSurface(event: MapHitEvent): MapSurface | null {
  if (!isMarkerHit(event)) return null;
  if (!event.target.marker.id.startsWith(EXCEPTION_MARKER_ID_PREFIX)) {
    return null;
  }
  const popup = event.target.marker.popup;
  if (!popup) return null;
  const opts = {
    presentation: event.trigger === 'hover' ? 'tooltip' : 'popup',
    anchor: { maxWidth: '360' },
  } as const;
  if (event.target.marker.popupHtml) {
    return htmlSurface(popup, opts);
  }
  return textSurface(popup, opts);
}
